var checkValidLabel = function (label, nameOrId) {
    if (!label) {
        throw new Error("Labeling error for field ".concat(nameOrId, ":\nA valid and descriptive label is required for accessibility purposes. If a visible label is not required, pass hideLabel as prop."));
    }
};

export { checkValidLabel };
//# sourceMappingURL=accessibility.esm.js.map
